const INITIAL_STATE = {
  id: null,
  name: null,
  login: null,
  cpf: '',
  type: null,
};

export default function user(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@USER/LOGIN':
      return action.payload;
    default:
      return state;
  }
}
